export interface MangaWork {
  title: string;
  author: string;
  type: string;
  chapters: number;
  weeklyUpdate: string;
  heat: string;
  cover: string;
  tags: string[];
  description: string;
}

export interface SerializedItem {
  title: string;
  author: string;
  category: string;
  chapters: number;
  progress: number;
  nextUpdate: string;
  cover: string;
  updateBadge: string;
}

export interface Category {
  name: string;
  icon: string;
  works: number;
  desc: string;
}

export interface Faq {
  q: string;
  a: string;
}

export interface Testimonial {
  name: string;
  role: string;
  text: string;
  avatar: string;
}

export const heroCover =
  "https://readdy.ai/api/search-image?query=stylish%20chinese%20manga%20collage%20with%20playful%20papaya%20fruit%20mascot%2C%20open%20comic%20panels%2C%20warm%20coral%20orange%20and%20golden%20yellow%20palette%2C%20energetic%20modern%20webcomic%20illustration%2C%20clean%20composition%20with%20soft%20paper%20texture%20background&width=1600&height=900&seq=manga-hero-01&orientation=landscape";

export const rankingCovers = {
  week:
    "https://readdy.ai/api/search-image?query=mystical%20ancient%20chess%20game%20fantasy%20manga%20cover%2C%20mysterious%20young%20strategist%20and%20glowing%20game%20pieces%2C%20warm%20orange%20and%20gold%20tones%2C%20vibrant%20webcomic%20illustration%2C%20clean%20background&width=600&height=800&seq=manga-cov-01&orientation=portrait",
  month:
    "https://readdy.ai/api/search-image?query=space%20ranger%20adventure%20manga%20cover%2C%20young%20pilot%20in%20modern%20mecha%20suit%20with%20galaxy%20nebula%20background%2C%20warm%20amber%20and%20teal%20tones%2C%20vibrant%20webcomic%20illustration%2C%20clean%20background&width=600&height=800&seq=manga-cov-02&orientation=portrait",
  all:
    "https://readdy.ai/api/search-image?query=street%20food%20gourmet%20fantasy%20manga%20cover%2C%20cute%20chef%20with%20steaming%20noodle%20bowl%20and%20lantern%20alley%2C%20warm%20golden%20and%20coral%20tones%2C%20vibrant%20webcomic%20illustration%2C%20clean%20background&width=600&height=800&seq=manga-cov-03&orientation=portrait",
};

export const rankings = {
  week: [
    { title: "御灵棋局", author: "沐春风", type: "古风·棋局", chapters: 128, weeklyUpdate: "周更2话", heat: "986.3万", rank: 1 },
    { title: "星野游侠", author: "川流", type: "科幻·冒险", chapters: 96, weeklyUpdate: "周更3话", heat: "912.7万", rank: 2 },
    { title: "南巷食肆", author: "一勺盐", type: "美食·治愈", chapters: 154, weeklyUpdate: "周更2话", heat: "875.1万", rank: 3 },
    { title: "山海异闻录", author: "白泽", type: "志怪·灵异", chapters: 110, weeklyUpdate: "周更1话", heat: "798.9万", rank: 4 },
    { title: "云端画师", author: "昼见", type: "都市·治愈", chapters: 132, weeklyUpdate: "周更2话", heat: "763.5万", rank: 5 },
    { title: "守夜人档案", author: "时雨", type: "悬疑·冒险", chapters: 87, weeklyUpdate: "周更2话", heat: "701.2万", rank: 6 },
    { title: "浮生客栈", author: "青梧", type: "古风·群像", chapters: 168, weeklyUpdate: "周更3话", heat: "688.0万", rank: 7 },
    { title: "纸鸢长安", author: "拾贰", type: "古风·武侠", chapters: 121, weeklyUpdate: "周更1话", heat: "645.6万", rank: 8 },
  ],
  month: [
    { title: "星野游侠", author: "川流", type: "科幻·冒险", chapters: 96, weeklyUpdate: "周更3话", heat: "3012万", rank: 1 },
    { title: "南巷食肆", author: "一勺盐", type: "美食·治愈", chapters: 154, weeklyUpdate: "周更2话", heat: "2788万", rank: 2 },
    { title: "御灵棋局", author: "沐春风", type: "古风·棋局", chapters: 128, weeklyUpdate: "周更2话", heat: "2605万", rank: 3 },
    { title: "云端画师", author: "昼见", type: "都市·治愈", chapters: 132, weeklyUpdate: "周更2话", heat: "2409万", rank: 4 },
    { title: "守夜人档案", author: "时雨", type: "悬疑·冒险", chapters: 87, weeklyUpdate: "周更2话", heat: "2231万", rank: 5 },
    { title: "山海异闻录", author: "白泽", type: "志怪·灵异", chapters: 110, weeklyUpdate: "周更1话", heat: "2116万", rank: 6 },
  ],
  all: [
    { title: "南巷食肆", author: "一勺盐", type: "美食·治愈", chapters: 154, weeklyUpdate: "周更2话", heat: "10246万", rank: 1 },
    { title: "浮生客栈", author: "青梧", type: "古风·群像", chapters: 168, weeklyUpdate: "周更3话", heat: "9877万", rank: 2 },
    { title: "御灵棋局", author: "沐春风", type: "古风·棋局", chapters: 128, weeklyUpdate: "周更2话", heat: "9312万", rank: 3 },
    { title: "星野游侠", author: "川流", type: "科幻·冒险", chapters: 96, weeklyUpdate: "周更3话", heat: "8655万", rank: 4 },
    { title: "云端画师", author: "昼见", type: "都市·治愈", chapters: 132, weeklyUpdate: "周更2话", heat: "7890万", rank: 5 },
    { title: "纸鸢长安", author: "拾贰", type: "古风·武侠", chapters: 121, weeklyUpdate: "周更1话", heat: "7213万", rank: 6 },
  ],
};

export const serialized: SerializedItem[] = [
  {
    title: "御灵棋局",
    author: "沐春风",
    category: "古风奇幻",
    chapters: 128,
    progress: 72,
    nextUpdate: "周五 20:00",
    cover:
      "https://readdy.ai/api/search-image?query=mystical%20ancient%20chess%20game%20fantasy%20manga%20cover%2C%20mysterious%20young%20strategist%20and%20glowing%20game%20pieces%2C%20warm%20orange%20and%20gold%20tones%2C%20vibrant%20webcomic%20illustration%2C%20clean%20background&width=600&height=800&seq=manga-cov-01&orientation=portrait",
    updateBadge: "今日更新",
  },
  {
    title: "南巷食肆",
    author: "一勺盐",
    category: "美食治愈",
    chapters: 154,
    progress: 88,
    nextUpdate: "周三 12:00",
    cover:
      "https://readdy.ai/api/search-image?query=street%20food%20gourmet%20fantasy%20manga%20cover%2C%20cute%20chef%20with%20steaming%20noodle%20bowl%20and%20lantern%20alley%2C%20warm%20golden%20and%20coral%20tones%2C%20vibrant%20webcomic%20illustration%2C%20clean%20background&width=600&height=800&seq=manga-cov-03&orientation=portrait",
    updateBadge: "昨日更新",
  },
  {
    title: "星野游侠",
    author: "川流",
    category: "科幻冒险",
    chapters: 96,
    progress: 61,
    nextUpdate: "周六 21:00",
    cover:
      "https://readdy.ai/api/search-image?query=space%20ranger%20adventure%20manga%20cover%2C%20young%20pilot%20in%20modern%20mecha%20suit%20with%20galaxy%20nebula%20background%2C%20warm%20amber%20and%20teal%20tones%2C%20vibrant%20webcomic%20illustration%2C%20clean%20background&width=600&height=800&seq=manga-cov-02&orientation=portrait",
    updateBadge: "周更",
  },
  {
    title: "山海异闻录",
    author: "白泽",
    category: "志怪灵异",
    chapters: 110,
    progress: 55,
    nextUpdate: "周四 19:00",
    cover:
      "https://readdy.ai/api/search-image?query=mythical%20creatures%20fantasy%20manga%20cover%2C%20Chinese%20fox%20spirit%20and%20mountain%20deity%20with%20mystic%20glow%2C%20warm%20orange%20and%20green%20tones%2C%20vibrant%20webcomic%20illustration%2C%20clean%20background&width=600&height=800&seq=manga-cov-04&orientation=portrait",
    updateBadge: "周更",
  },
  {
    title: "云端画师",
    author: "昼见",
    category: "都市治愈",
    chapters: 132,
    progress: 79,
    nextUpdate: "周二 18:30",
    cover:
      "https://readdy.ai/api/search-image?query=young%20digital%20artist%20creating%20dream%20worlds%20with%20light%20brushes%2C%20cozy%20studio%20manga%20cover%2C%20warm%20golden%20and%20coral%20tones%2C%20vibrant%20webcomic%20illustration%2C%20clean%20background&width=600&height=800&seq=manga-cov-05&orientation=portrait",
    updateBadge: "今日更新",
  },
  {
    title: "守夜人档案",
    author: "时雨",
    category: "悬疑冒险",
    chapters: 87,
    progress: 47,
    nextUpdate: "周日 22:00",
    cover:
      "https://readdy.ai/api/search-image?query=night%20watcher%20detective%20manga%20cover%2C%20mysterious%20young%20investigator%20with%20lantern%20in%20rainy%20city%20alley%2C%20warm%20amber%20and%20teal%20tones%2C%20vibrant%20webcomic%20illustration%2C%20clean%20background&width=600&height=800&seq=manga-cov-06&orientation=portrait",
    updateBadge: "周更",
  },
];

export const featured = [
  {
    title: "浮生客栈",
    author: "青梧",
    tag: "本周霸榜",
    chapters: 168,
    heat: "9.8万人在追",
    cover:
      "https://readdy.ai/api/search-image?query=ancient%20Chinese%20inn%20fantasy%20manga%20cover%2C%20warm%20lantern%20lit%20wooden%20tavern%20with%20colorful%20guests%2C%20golden%20and%20coral%20tones%2C%20vibrant%20webcomic%20illustration%2C%20clean%20background&width=600&height=800&seq=manga-cov-07&orientation=portrait",
    desc: "一间开在人间与妖界交界处的客栈，每晚都有说不完的故事。本周连续五天登顶人气榜，周更稳定不断更。",
  },
  {
    title: "纸鸢长安",
    author: "拾贰",
    tag: "热度飙升",
    chapters: 121,
    heat: "7.6万人在追",
    cover:
      "https://readdy.ai/api/search-image?query=ancient%20capital%20wuxia%20manga%20cover%2C%20young%20swordsman%20with%20paper%20kite%20over%20traditional%20Chinese%20city%20rooftops%2C%20warm%20orange%20and%20gold%20tones%2C%20vibrant%20webcomic%20illustration%2C%20clean%20background&width=600&height=800&seq=manga-cov-08&orientation=portrait",
    desc: "长安城的纸鸢会说话，牵线人守着王朝的秘密。霸榜新秀，开播两周便冲进总榜前十。",
  },
  {
    title: "守夜人档案",
    author: "时雨",
    tag: "读者口碑",
    chapters: 87,
    heat: "6.1万人在追",
    cover:
      "https://readdy.ai/api/search-image?query=night%20watcher%20detective%20manga%20cover%2C%20mysterious%20young%20investigator%20with%20lantern%20in%20rainy%20city%20alley%2C%20warm%20amber%20and%20teal%20tones%2C%20vibrant%20webcomic%20illustration%2C%20clean%20background&width=600&height=800&seq=manga-cov-06&orientation=portrait",
    desc: "每一份档案背后，都是一个无人知晓的夜晚。剧情烧脑反转，稳居悬疑分类口碑榜第一。",
  },
];

export const categories: Category[] = [
  { name: "古风奇幻", icon: "ri-building-2-fill", works: 1248, desc: "棋局、仙侠、江湖群像" },
  { name: "科幻冒险", icon: "ri-rocket-2-fill", works: 863, desc: "星际、机甲、末世求生" },
  { name: "美食治愈", icon: "ri-restaurant-2-fill", works: 592, desc: "烟火气与暖心的日常" },
  { name: "悬疑冒险", icon: "ri-spy-fill", works: 731, desc: "烧脑反转、惊悚谜案" },
  { name: "都市情感", icon: "ri-building-fill", works: 1026, desc: "成长、恋爱与人生选择" },
  { name: "志怪灵异", icon: "ri-ghost-2-fill", works: 415, desc: "山海异闻、都市怪谈" },
];

export const faqs: Faq[] = [
  {
    q: "追更进度条是怎么同步的？",
    a: "你在番木瓜漫画收藏的每部连载都会自动生成一根追更进度条，标出已读章节与最新话的位置。每次进入页面都会自动同步服务器上的阅读进度，换设备也能接着读，不怕长期连载断更追不上。",
  },
  {
    q: "热门榜单多久更新一次？",
    a: "热门榜单按周榜、月榜与总榜三档呈现，周榜与月榜每日凌晨自动刷新，总榜每周一上午重排。热度综合播放量、追更人数与读者互动计算，力求真实反映当下最受关注的作品。",
  },
  {
    q: "「霸榜作品」是什么意思？",
    a: "霸榜作品指连续多日或连续多周停留在榜单前列的连载。站点会为这类作品打上专属标识，并在「周更追踪」中醒目标注最新话进度，方便你第一时间看到它们是否已经更新。",
  },
  {
    q: "长期连载的漫画会不会断更？",
    a: "站点优先收录稳定周更与固定更新时间的长篇连载，并为每部作品标注预计更新时间。若作者临时休刊，页面会显示「本周休刊」提醒，并保留已追到的章节进度，恢复更新后进度条自动衔接。",
  },
  {
    q: "需要在番木瓜漫画注册账号吗？",
    a: "浏览榜单和章节无需注册。只有收藏作品、开启追更进度条、同步跨端阅读记录时才需要登录。登录后进度自动云同步，多设备随时接着看。",
  },
  {
    q: "作品的信息和更新数据准确吗？",
    a: "站点数据由人工编辑部与实时抓取双重校验，章节数、热度与更新时间每日校准。若发现某部作品信息有误，可通过页面底部的联系方式反馈，编辑部会在 24 小时内核实并修正。",
  },
];

export const testimonials: Testimonial[] = [
  {
    name: "阿桃",
    role: "连载深度读者",
    text: "追了三年长篇终于不用记话数了，进度条一点就知道自己看到哪，换手机接着看特别顺。",
    avatar:
      "https://readdy.ai/api/search-image?query=friendly%20young%20woman%20avatar%20illustration%2C%20warm%20coral%20and%20gold%20tones%2C%20flat%20modern%20cartoon%20style%2C%20clean%20background&width=200&height=200&seq=manga-ava-01&orientation=squarish",
  },
  {
    name: "老周",
    role: "漫画编辑",
    text: "榜单数据更新得很勤，追更节奏和最新话进度都标得清清楚楚，找周更作品效率高多了。",
    avatar:
      "https://readdy.ai/api/search-image?query=friendly%20middle%20aged%20man%20avatar%20illustration%2C%20warm%20amber%20and%20teal%20tones%2C%20flat%20modern%20cartoon%20style%2C%20clean%20background&width=200&height=200&seq=manga-ava-02&orientation=squarish",
  },
  {
    name: "小鹿",
    role: "漫画新手",
    text: "第一次追长连载就是在这里，进度条和更新提醒让我再也没断过追，好评。",
    avatar:
      "https://readdy.ai/api/search-image?query=cheerful%20young%20girl%20avatar%20illustration%2C%20warm%20golden%20and%20coral%20tones%2C%20flat%20modern%20cartoon%20style%2C%20clean%20background&width=200&height=200&seq=manga-ava-03&orientation=squarish",
  },
];